import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DefConfig } from 'src/app/_models/province';
import { HttpService } from 'src/app/_services';
import { environment } from 'src/environments/environment';

import OlMap from 'ol/Map';
import OlXYZ from 'ol/source/XYZ';
import OlTileLayer from 'ol/layer/Tile';
import OlView from 'ol/View';
import OlControl from 'ol/control';
import { defaults as defaultControls, ZoomToExtent } from 'ol/control';
import { applyTransform } from 'ol/extent';
import { fromLonLat, getTransform, transform, toLonLat } from 'ol/proj';
import { TileWMS, OSM, Vector as VectorSource, ImageWMS, BingMaps } from 'ol/source';
import { Image as ImageLayer, Tile as TileLayer } from 'ol/layer';
import OlLayerGroup from 'ol/layer/Group';
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import Overlay from 'ol/Overlay';
import { Fill, Stroke, Style } from 'ol/style';
import { ConfigService } from 'src/app/_services/config.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-map-capture',
  templateUrl: './map-capture.component.html',
  styleUrls: ['./map-capture.component.scss']
})
export class MapCaptureComponent implements OnInit, OnChanges, AfterViewInit{

  @Input() parcel_code: string;
  @Input() map_id: string;
  @Input() annual: number;
  @Output() base64Out = new EventEmitter<string>();

  map: OlMap;
  source: OlXYZ;
  layer: OlTileLayer;
  view: OlView;
  control: OlControl;
  status = false;
  basemapGroup = OlLayerGroup;
  defConf: DefConfig;
  vecLayer: VectorLayer;
  vectorSource: VectorSource;
  wms_tile: any;
  parcel_json: any;
  extentTxt: string;
  extent2: any;
  extent: number[];
  vecLayerSurvey: VectorLayer;
  fileName: string;
  overlay: any;
  container: HTMLElement;
  content: HTMLElement;
  closer: HTMLElement;

  constructor(private http: HttpService,private configService:ConfigService,private activatedRoute: ActivatedRoute) { }


  ngOnInit() {
    this.parcel_code = this.activatedRoute.snapshot.queryParams["pc"];
    this.map_id = 'capture_map';
  }

  ngOnChanges() {
    this.loadMap();
  }

  loadMap() {
    if (this.map != undefined) {
      this.map.removeLayer(this.vecLayer);
      if (
        this.parcel_code != "null" &&
        this.parcel_code != undefined &&
        this.parcel_code != ""
      ) {
        this.http
          .requestPost("map/json", { pc: this.parcel_code })
          .subscribe((res) => {
            this.parcel_json = res;
            this.vectorSource = new VectorSource({
              features: new GeoJSON().readFeatures(this.parcel_json, {
                featureProjection: "EPSG:3857",
              }),
            });

            this.vecLayer = new VectorLayer({
              source: this.vectorSource,
              params: { LAYERS: "parcel_json", zIndex: 99 },
              style: new Style({
                stroke: new Stroke({
                  color: "#eedd00",
                  width: 2,
                }),
                fill: new Fill({
                  color: "rgba(252,154,36,0)",
                }),
              }),
            });
            this.vectorSource.refresh();
            this.map.addLayer(this.vecLayer);
            var extent = this.vectorSource.getExtent();
            this.map.getView().fit(extent, this.map.getSize());


          });
      }
    }
  }


  setExtent() {
    this.map.getView().fit(this.extent2, this.map.getSize());
  }

  ngAfterViewInit() {
  
    var url = this.configService.config.Map + "MapProxy/?";
    this.http.requestGet("LtaxGIS/extent").subscribe((res) => {
      this.extentTxt = res.extent;
      this.extent = this.extentTxt.split(",").map(Number);
      var fromLonLat = getTransform("EPSG:4326", "EPSG:3857");
      this.extent2 = applyTransform(this.extent, fromLonLat);
      this.view = new OlView({
        center: transform([100.5, 7], "EPSG:4326", "EPSG:3857"),
        zoom: 4,
      });

      this.basemapGroup = new OlLayerGroup({
        layers: [
          new TileLayer({
            source: new OSM({
              url: "https://mt{0-3}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
            }),
          })
        ],
      });
      // this.wms_tile = new TileLayer({
      //   source: new TileWMS({
      //     url: url,
      //     params: {
      //       LAYERS: "f",
      //       TILED: false,
      //       map: "ltax.map",
      //       crossOrigin: "anonymous",
      //     },
      //     serverType: "geoserver",
      //   }),
      // });

      this.map = new OlMap({
        target: this.map_id,
        // layers: [this.basemapGroup, this.wms_tile],
        layers: [this.basemapGroup],
        view: this.view,
        controls: defaultControls({zoom:false,attribution:false}),
      });
      this.map.getView().fit(this.extent2, this.map.getSize());
      this.loadMap();
    });
  }

}
